module.exports = __webpack_public_path__ + "static/media/my-account-bg.0cb5b615.jpg";